import * as types from '../mutation-types';
import { requestOnce } from '@/helpers/functions'

export default {
	namespaced: true,

	state: {
		notifications: [],
		unreadCount: 0,
	},

	actions: {
		fetchAll({ commit }, { fromDate, toDate }) {
			return requestOnce('/PlannedVisits/Mine/Unread', () => window.axios.get('/PlannedVisits/Mine/Unread', {
				params: { fromDate, toDate }
			})).then(({ data }) => {
				commit(types.STORE_NOTIFICATIONS, data);
				return data
			});
		},

		markAsRead({ commit }, { notificationId }) {
			return window.axios.put(`/PlannedVisitsNotification/${notificationId}`, null, { params: { notify: true } })
		},

		// ===== New notifications API (contract: /Notifications, /Users/device-token) =====

		// in-app notifications list
		fetchNotifications({ commit }) {
			return requestOnce('/Notifications', () => window.axios.get('/Notifications')).then(({ data }) => {
				commit(types.STORE_NOTIFICATIONS, data);
				return data
			});
		},

		// unread count for the bell badge
		fetchUnreadCount({ commit }) {
			return requestOnce('/Notifications/UnreadCount', () => window.axios.get('/Notifications/UnreadCount')).then(({ data }) => {
				commit(types.STORE_NOTIFICATIONS_UNREAD_COUNT, data);
				return data
			});
		},

		markNotificationAsRead(context, { notificationId }) {
			return window.axios.put(`/Notifications/${notificationId}/MarkAsRead`)
		},

		markAllAsRead() {
			return window.axios.put('/Notifications/MarkAllAsRead')
		},

		// FCM device token — register on login / app start
		registerDeviceToken(context, { token }) {
			return window.axios.post('/Users/device-token', { token }, { preventHandling: true })
		},

		// FCM device token — unregister on logout
		unregisterDeviceToken(context, { token }) {
			return window.axios.post('/Users/Logout', { token }, { preventHandling: true })
		}
	},

	mutations: {
		[types.STORE_NOTIFICATIONS](state, notifications) {
			state.notifications = notifications;
		},

		[types.STORE_NOTIFICATIONS_UNREAD_COUNT](state, count) {
			state.unreadCount = count;
		}
	},

	getters: {
		getNotificationById: state => id => state.notifications.find(c => c.id === id)
	}
}